// extracted by mini-css-extract-plugin
module.exports = {"timeSlots":"activity-time-slots_timeSlots__3cFOo","timeSlotTitle":"activity-time-slots_timeSlotTitle__3Yqpq","timeWrapper":"activity-time-slots_timeWrapper__3FwE8"};